export default __webpack_public_path__ + "static/media/screen3.f064f8f6.png";